import { environment } from '../../../../../environments/environment';
import { getUserData } from '../../../../util/manageUserData';

export class Config {
  constructor() {}

  checkEnv = environment.client_env == 'pandg' ? false : true;
  getNavConfiguration(config) {
    if (config == 'dashboard') {
      return this.nav_dashboard;
    } else if (config == 'glimpse-main') {
      return this.nav_glimpse_main;
    } else if (config == 'nihilent') {
      return this.nav_nihilent;
    } else if (config == 'c2c-pos') {
      return this.nav_c2c_pos;
    } else if (config == 'GroundLevelInsights') {
      return this.nav_groundlevel_insights;
    } else if (config == 'dashboard-pos') {
      return this.nav_dashboard_pos_insights;
    } else if (config == 'shell') {
      return this.nav_shell;
    } else if (config == 'covid') {
      return this.nav_covid;
    } else if (config == 'pandg') {
      return this.nav_covid;
    } else if (config == 'pos-main') {
      return this.all_test;
    } else if (config == 'pos-insights-demo') {
      return this.nav_pos_insights_demo;
    } else if (config == 'mands') {
      return this.nav_mands;
    } else {
      return this.all_test;
    }
  }

  getDynamicNavConfiguration() {
    const userDataStorage = getUserData();
    if (this.checkEnv) {
      const storeAccessFeatures: any[] =
        userDataStorage['store_access_dictionary'];
      let sideSectionArray = [];
      if (Object.entries(storeAccessFeatures).length === 0) {
        sideSectionArray = this.getDefaultFeaturesOfUser();
      } else {
        sideSectionArray = this.getFeaturesOfSelectedStores();
      }
      return sideSectionArray;
    } else {
      let selectedStores = JSON.parse(localStorage.getItem('selectedLocation'));
      var newStores = [];
      const sideSectionArray = [];
      for (let prop in selectedStores) {
        if (selectedStores[prop]) {
          newStores.push(prop);
        }
      }
      newStores.forEach((store) => {
        const sideSection: any[] =
          userDataStorage['store_access_dictionary'][store];
        sideSection.forEach((item) => {
          if (item.unique_key === 'line') {
            if (sideSectionArray.indexOf({ isSection: true }) == -1) {
              sideSectionArray.push({
                isSection: true,
              });
            }
          } else {
            let temp = this.all_test_object[item.unique_key];

            if (temp) {
              temp.disabled = item.is_enabled === '1' ? false : true;
              if (sideSectionArray.indexOf(temp) == -1) {
                sideSectionArray.push(temp);
              }
            }
          }
        });
      });
      return sideSectionArray;
    }
  }

  getDefaultFeaturesOfUser() {
    const userDataStorage = getUserData();
    const sideSection: any[] = userDataStorage['side_section_access'];

    const sideSectionArray = [];
    sideSection.forEach((item) => {
      if (item.unique_key === 'line') {
        sideSectionArray.push({
          isSection: true,
        });
      } else {
        let temp = this.all_test_object[item.unique_key];

        if (temp) {
          temp.disabled = item.is_enabled === '1' ? false : true;
          sideSectionArray.push(temp);
        }
      }
    });
    return sideSectionArray;
  }

  getFeaturesOfSelectedStores() {
    let selectedStores = JSON.parse(localStorage.getItem('selectedLocation'));
    var newStores = [];
    let sideSectionArray = [];
    for (let prop in selectedStores) {
      if (selectedStores[prop]) {
        newStores.push(prop);
      }
    }
    let sideSection = this.getSidesectionOfAllSelectedStores(newStores);
    sideSection.forEach((item) => {
      if (item.unique_key === 'line') {
        if (sideSectionArray.indexOf({ isSection: true }) == -1) {
          sideSectionArray.push({
            isSection: true,
          });
        }
      } else {
        let temp = this.all_test_object[item.unique_key];

        if (temp) {
          temp.disabled = item.is_enabled === '1' ? false : true;
          if (sideSectionArray.indexOf(temp) == -1) {
            sideSectionArray.push(temp);
          }
        }
      }
    });
    return sideSectionArray;
  }

  getSidesectionOfAllSelectedStores(storesArray) {
    const userDataStorage = getUserData();
    let storeWiseSideSectionArr = [];
    storesArray.forEach((store) => {
      let sideSection: any[] =
        userDataStorage['store_access_dictionary'][store];
      if (sideSection) {
        sideSection.forEach((item) => {
          if (storeWiseSideSectionArr.indexOf(item) == -1) {
            storeWiseSideSectionArr.push(item);
          }
        });
      }
    });
    storeWiseSideSectionArr = this.sortAndAddLine(storeWiseSideSectionArr);
    return storeWiseSideSectionArr;
  }

  sortAndAddLine(sideSecArray) {
    let sortedArray = sideSecArray.sort((a, b) => {
      return a.order_number - b.order_number;
    });
    let lineObj = {
      id: 4,
      name: 'Line',
      unique_key: 'line',
      is_enabled: '1',
      order_number: '27',
      group_number: '12',
    };
    let sortedSidenavWithLines = [];
    let last_group_number = 0;
    sortedArray.forEach((item) => {
      let current_group_number = item.group_number;
      if (last_group_number != current_group_number) {
        if (last_group_number != 0) {
          sortedSidenavWithLines.push(lineObj);
        }
        last_group_number = current_group_number;
      }
      sortedSidenavWithLines.push(item);
    });
    return sortedSidenavWithLines;
  }

  getFirstNavItem() {
    const userDataStorage = getUserData();
    if (this.checkEnv) {
      const firstItemOfSideSection = userDataStorage['side_section_access'][0];
      if (firstItemOfSideSection) {
        const firstItemDetails =
          this.all_test_object[firstItemOfSideSection.unique_key];
        return firstItemDetails;
      }
    } else {
      let selectedStores = JSON.parse(localStorage.getItem('selectedLocation'));
      var newStores = [];
      for (let prop in selectedStores) {
        if (selectedStores[prop]) {
          newStores.push(prop);
        }
      }
      newStores.forEach((store) => {
        const firstItemOfSideSection =
          userDataStorage['store_access_dictionary'][store][0];
        if (firstItemOfSideSection) {
          const firstItemDetails =
            this.all_test_object[firstItemOfSideSection.unique_key];
          return firstItemDetails;
        }
      });
    }
  }

  private all_test = [
    {
      title: 'Footfall',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Explore',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Engagement',
      path: 'conversion',
      icon: 'history',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Staff Interaction',
      path: 'staff-interaction',
      icon: 'history',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Just In Time Tilling',
      path: 'queue-analysis',
      icon: 'family_restroom',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Entries/Exits',
      path: 'lo',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Vehicle Analysis',
      path: 'vehicle-analysis',
      icon: 'directions_car',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Queue Analysis',
      path: 'queue-length',
      icon: 'family_restroom',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Costa Queue Analysis',
      path: 'costa-queue-analysis',
      icon: 'family_restroom',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Sanitisation',
      path: 'sanitation',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Conversion',
      path: 'compare',
      icon: 'insights',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Gate Data',
      path: 'gate-date',
      icon: 'meeting_room',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Gate Summary',
      path: 'gate-analysis',
      icon: 'multiline_chart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Camera Status',
      path: 'camera-status',
      icon: 'multiline_chart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Report Data',
      path: 'report-data',
      icon: 'assessment',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Reports',
      path: 'report-section',
      icon: 'assessment',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Support',
      path: 'support',
      icon: 'support',
      disabled: false,
      hidden: false,
    },
  ];
  private all_test_object = {
    queue_analysis: {
      title: 'Just In Time Tilling',
      path: 'queue-analysis',
      icon: 'notification_important',
      disabled: false,
      hidden: false,
    },
    stop_look_go: {
      title: 'Stop Look Go',
      path: 'engagement_times_alert',
      icon: 'notification_important',
      disabled: false,
      hidden: false,
    },
    staff_interaction: {
      title: 'Staff Interaction',
      path: 'staff-interaction',
      icon: 'history',
      disabled: false,
      hidden: false,
    },
    footfall: {
      title: 'Summary',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    explore: {
      title: 'Footfall',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: false,
      hidden: false,
    },

    demographics: {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: false,
      hidden: false,
    },
    heatmap: {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: false,
      hidden: false,
    },

    mhe_heatmap: {
      title: 'MHE Heatmaps',
      path: 'mhe-heatmap',
      icon: 'zoom_out_map',
      disabled: false,
      hidden: false,
    },

    ppe_occupancy: {
      title: 'PPE Violation',
      path: 'ppe-occupancy',
      icon: 'rule',
      disabled: false,
      hidden: false,
    },

    engagement: {
      title: 'Engagement',
      path: 'conversion',
      icon: 'history',
      disabled: false,
      hidden: false,
    },
    entries_exit: {
      title: 'Entries/Exits',
      path: 'lo',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    electric_vehicle: {
      title: 'Vehicle Analysis',
      path: 'vehicle-analysis',
      icon: 'directions_car',
      disabled: false,
      hidden: false,
    },

    live_occupancy: {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },
    virtual_demarkation_occupancy: {
      title: 'Virtual Demarcation',
      path: 'virtual-demarkation-occupancy',
      icon: 'remove_road',
      disabled: false,
      hidden: false,
    },
    boundary_occupancy: {
      title: 'Boundary Survalliance',
      path: 'p&g-boundary',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },
    maintenance: {
      title: 'Maintenance',
      path: 'maintenance',
      icon: 'space_dashboard',
      disabled: false,
      hidden: false,
    },
    user_access: {
      title: 'User Access Management',
      path: 'user-access',
      icon: 'space_dashboard',
      disabled: false,
      hidden: false,
    },
    vegetation: {
      title: 'Vegetation',
      path: 'vegetation',
      icon: 'format_align_center',
      disabled: false,
      hidden: false,
    },
    data_fill: {
      title: 'Data Fill',
      path: 'data-fill',
      icon: 'note_add',
      disabled: false,
      hidden: false,
    },
    social_distance: {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    mhe_collision: {
      title: 'MHE Near Miss',
      path: 'mhe-collision',
      icon: 'precision_manufacturing',
      disabled: false,
      hidden: false,
    },
    mobile_violation: {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },
    handrail_violation: {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },
    queue: {
      title: 'Queue Analysis',
      path: 'queue-length',
      icon: 'family_restroom',
      disabled: false,
      hidden: false,
    },
    drive_thru_display: {
      title: 'Costa Queue Analysis',
      path: 'costa-queue-analysis',
      icon: 'family_restroom',
      disabled: false,
      hidden: false,
    },

    mask_compliance: {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },

    sanitisation: {
      title: 'Sanitisation',
      path: 'sanitation',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },

    compare: {
      title: 'Conversion',
      path: 'compare',
      icon: 'insights',
      disabled: false,
      hidden: false,
    },

    gate_data: {
      title: 'Gate Data',
      path: 'gate-date',
      icon: 'meeting_room',
      disabled: false,
      hidden: false,
    },
    gate_status: {
      title: 'Gate Summary',
      path: 'gate-analysis',
      icon: 'multiline_chart',
      disabled: false,
      hidden: false,
    },
    camera_status: {
      title: 'Camera Status',
      path: 'camera-status',
      icon: 'multiline_chart',
      disabled: false,
      hidden: false,
    },
    report: {
      title: 'Report Data',
      path: 'report-data',
      icon: 'assessment',
      disabled: false,
      hidden: false,
    },
    report_section: {
      title: 'Reports',
      path: 'report-section',
      icon: 'assessment',
      disabled: false,
      hidden: false,
    },
    support: {
      title: 'Support',
      path: 'support',
      icon: 'support',
      disabled: false,
      hidden: false,
    },
    client_onboarding: {
      title: 'Client Onboarding',
      path: 'client-onboarding',
      icon: 'space_dashboard',
      disabled: false,
      hidden: false,
    },
    lighting: {
      title: 'Lighting',
      path: 'lighting',
      icon: 'light',
      disabled: false,
      hidden: false,
    },
    rail_head: {
      title: 'Rail Head',
      path: 'rail_head',
      icon: 'railway_alert',
      disabled: false,
      hidden: false,
    },
    signaling: {
      title: 'Signaling',
      path: 'signaling',
      icon: 'traffic',
      disabled: false,
      hidden: false,
    },
    accuracy_report: {
      title: 'Accuracy Report',
      path: 'accuracy-report',
      icon: 'space_dashboard',
      disabled: false,
      hidden: false,
    },
  };

  private nav_covid = [
    {
      title: 'Footfall',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: true,
      hidden: false,
    },
    {
      title: 'Explore',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: true,
      hidden: false,
    },

    {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: true,
      hidden: false,
    },
    {
      isSection: true,
    },
    {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: true,
      hidden: false,
    },

    {
      title: 'Engagement',
      path: 'conversion',
      icon: 'history',
      disabled: true,
      hidden: false,
    },
    {
      title: 'Entries/Exits',
      path: 'lo',
      icon: 'filter_center_focus',
      disabled: true,
      hidden: false,
    },

    {
      isSection: true,
    },

    {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Virtual Demarkation Occupancy',
      path: 'virtual-demarkation-occupancy',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Boundary Survalliance',
      path: 'p&g-boundary',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },
  ];

  private nav_dashboard = [
    {
      title: 'Footfall',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: true,
      hidden: false,
    },
    {
      title: 'Explore',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: true,
      hidden: false,
    },

    {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: true,
      hidden: false,
    },

    {
      isSection: true,
    },
    {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: true,
      hidden: false,
    },

    // {
    //   title:'Heatmap',
    //   path:'heatmaps',
    //   icon:'zoom_out_map',
    //   disabled:false,
    //   hidden:false
    // },

    {
      title: 'Engagement',
      path: 'conversion',
      icon: 'history',
      disabled: true,
      hidden: false,
    },
    {
      title: 'Entries/Exits',
      path: 'lo',
      icon: 'filter_center_focus',
      disabled: true,
      hidden: false,
    },
    {
      isSection: true,
    },

    // {
    //   title:'Occupancy',
    //   path:'passer-by',
    //   icon:'transfer_within_a_station',
    //   disabled:false,
    //   hidden:false
    // },

    // {

    //   isSection:true
    // },
    // {
    //   title:'Footfall',
    //   path:'footfalls',
    //   icon:'filter_center_focus',
    //   disabled:false,
    //   hidden:false
    // },
    // {
    //   title:'Explore',
    //   path:'explore-graphs',
    //   icon:'bubble_chart',
    //   disabled:false,
    //   hidden:false
    // },

    {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Queue Analysis',
      path: 'queue-length',
      icon: 'family_restroom',
      disabled: false,
      hidden: true,
    },

    {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },
    // {
    //   title:'Sanitisation',
    //   path:'sanitation',
    //   icon:'masks',
    //   disabled:false,
    //   hidden:false
    // },
    {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Conversion',
      path: 'compare',
      icon: 'insights',
      disabled: false,
      hidden: true,
    },
    {
      isSection: false,
    },
    {
      title: 'Gate Data',
      path: 'gate-date',
      icon: 'meeting_room',
      disabled: true,
      hidden: true,
    },
    {
      title: 'Report Data',
      path: 'report-data',
      icon: 'assessment',
      disabled: true,
      hidden: true,
    },
    {
      title: 'Reports',
      path: 'report-section',
      icon: 'assessment',
      disabled: true,
      hidden: true,
    },
  ];

  private nav_glimpse_main = [
    {
      title: 'Footfall',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Explore',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: false,
      hidden: false,
    },
    {
      isSection: true,
    },
    {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Engagement',
      path: 'conversion',
      icon: 'history',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Entries/Exits',
      path: 'lo',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },

    {
      isSection: true,
    },

    {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Reports',
      path: 'report-section',
      icon: 'assessment',
      disabled: false,
      hidden: false,
    },
  ];

  private nav_nihilent = [
    {
      title: 'Footfall',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Explore',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: false,
      hidden: false,
    },

    // {
    //   title:'Engagement',
    //   path:'conversion',
    //   icon:'history',
    //   disabled:true,
    //   hidden:false
    // },
    // {
    //   title:'Entries/Exits',
    //   path:'lo',
    //   icon:'filter_center_focus',
    //   disabled:true,
    //   hidden:false
    // },
    {
      isSection: true,
    },

    // {
    //   title:'Occupancy',
    //   path:'passer-by',
    //   icon:'transfer_within_a_station',
    //   disabled:false,
    //   hidden:false
    // },

    // {

    //   isSection:true
    // },
    // {
    //   title:'Footfall',
    //   path:'footfalls',
    //   icon:'filter_center_focus',
    //   disabled:false,
    //   hidden:false
    // },
    // {
    //   title:'Explore',
    //   path:'explore-graphs',
    //   icon:'bubble_chart',
    //   disabled:false,
    //   hidden:false
    // },

    {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },
    // {
    //   title:'Queue Analysis',
    //   path:'queue-length',
    //   icon:'family_restroom',
    //   disabled:false,
    //   hidden:false

    // },

    {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Sanitisation',
      path: 'sanitation',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },
    {
      isSection: true,
    },
    {
      title: 'Members',
      path: 'members',
      icon: 'person',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Reports',
      path: 'report_section',
      icon: 'assessment',
      disabled: false,
      hidden: false,
    },
  ];

  private nav_c2c_pos = [
    {
      title: 'Footfall',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Explore',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: false,
      hidden: false,
    },

    {
      isSection: true,
    },
    {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Engagement',
      path: 'conversion',
      icon: 'history',
      disabled: false,
      hidden: false,
    },

    {
      isSection: true,
    },

    // {

    //   isSection:true
    // },

    {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },
    // {

    {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },

    {
      isSection: true,
    },
    {
      title: 'Gate Data',
      path: 'gate-date',
      icon: 'meeting_room',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Report Data',
      path: 'report-data',
      icon: 'assessment',
      disabled: true,
      hidden: true,
    },
    {
      title: 'Reports',
      path: 'report-section',
      icon: 'assessment',
      disabled: true,
      hidden: true,
    },
  ];

  private nav_pos_insights_demo = [
    {
      title: 'Footfall',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Explore',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: false,
      hidden: false,
    },

    {
      isSection: true,
    },
    {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Engagement',
      path: 'conversion',
      icon: 'history',
      disabled: false,
      hidden: false,
    },

    {
      isSection: true,
    },

    // {

    //   isSection:true
    // },

    {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },
    // {

    {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },

    {
      isSection: true,
    },
    {
      title: 'Gate Data',
      path: 'gate-date',
      icon: 'meeting_room',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Report Data',
      path: 'report-data',
      icon: 'assessment',
      disabled: true,
      hidden: true,
    },
    {
      title: 'Reports',
      path: 'report-section',
      icon: 'assessment',
      disabled: true,
      hidden: true,
    },
  ];
  private nav_shell = [
    {
      title: 'Footfall',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Explore',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: false,
      hidden: false,
    },

    {
      isSection: true,
    },
    {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Engagement',
      path: 'conversion',
      icon: 'history',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Vehicle Analysis',
      path: 'vehicle-analysis',
      icon: 'directions_car',
      disabled: false,
      hidden: false,
    },
    {
      isSection: true,
    },

    {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Queue Analysis',
      path: 'queue-length',
      icon: 'family_restroom',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Reports',
      path: 'report-section',
      icon: 'assessment',
      disabled: false,
      hidden: false,
    },
  ];

  private nav_mands = [
    {
      title: 'Footfall',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Explore',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: false,
      hidden: false,
    },

    {
      isSection: true,
    },
    {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Engagement',
      path: 'conversion',
      icon: 'history',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },

    {
      isSection: true,
    },

    {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Queue Analysis',
      path: 'queue-length',
      icon: 'family_restroom',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Reports',
      path: 'report-section',
      icon: 'assessment',
      disabled: false,
      hidden: false,
    },
  ];

  private nav_groundlevel_insights = [
    {
      title: 'Footfall',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Explore',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: false,
      hidden: false,
    },
    {
      isSection: true,
    },
    {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: false,
      hidden: false,
    },

    // {
    //   title:'Heatmap',
    //   path:'heatmaps',
    //   icon:'zoom_out_map',
    //   disabled:false,
    //   hidden:false
    // },

    {
      title: 'Engagement',
      path: 'conversion',
      icon: 'history',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Entries/Exits',
      path: 'lo',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: true,
    },

    {
      isSection: true,
    },

    {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Reports',
      path: 'report-section',
      icon: 'assessment',
      disabled: false,
      hidden: false,
    },
  ];

  private nav_dashboard_pos_insights = [
    {
      title: 'Demographics',
      path: 'demographics',
      icon: 'how_to_reg',
      disabled: true,
      hidden: false,
    },
    {
      isSection: true,
    },
    {
      title: 'Heatmaps',
      path: 'heatmaps',
      icon: 'zoom_out_map',
      disabled: true,
      hidden: false,
    },

    {
      title: 'Engagement',
      path: 'conversion',
      icon: 'history',
      disabled: true,
      hidden: false,
    },
    {
      title: 'Entries/Exits',
      path: 'lo',
      icon: 'filter_center_focus',
      disabled: true,
      hidden: true,
    },
    {
      isSection: true,
    },
    {
      title: 'Footfall',
      path: 'footfalls',
      icon: 'filter_center_focus',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Explore',
      path: 'explore-graphs',
      icon: 'bubble_chart',
      disabled: false,
      hidden: false,
    },

    {
      title: 'Social Distance',
      path: 'sd',
      icon: '6_ft_apart',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mobile Violations',
      path: 'mobile-violation',
      icon: 'mobile_off',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Handrail Violations',
      path: 'handrail-violation',
      icon: 'escalator',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Mask Compliance',
      path: 'md',
      icon: 'masks',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Queue Analysis',
      path: 'queue-length',
      icon: 'family_restroom',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Occupancy',
      path: 'passer-by',
      icon: 'transfer_within_a_station',
      disabled: false,
      hidden: false,
    },
    {
      title: 'Reports',
      path: 'report-section',
      icon: 'assessment',
      disabled: false,
      hidden: false,
    },
  ];
}
